import { saveAs } from 'file-saver';
import { commentId } from '../layouts/fieldFarmerDetails/CommentsData';
import api from '../components/api/api';

export const safeConcat = (arr1, arr2, arr3) => {
  const safeArr1 = Array.isArray(arr1) ? arr1 : [];
  const safeArr2 = Array.isArray(arr2) ? arr2 : [];
  const safeArr3 = Array.isArray(arr3) ? arr3 : [];

  return [...safeArr1, ...safeArr2, ...safeArr3];
};

export const safeConcatTwo = (arr1, arr2) => {
  const safeArr1 = Array.isArray(arr1) ? arr1 : [];
  const safeArr2 = Array.isArray(arr2) ? arr2 : [];

  return [...safeArr1, ...safeArr2];
};

export function formatAllComments(farmComments, farmerComments) {
  const farmCommentsArr = safeConcat(
    farmComments?.RESOLVED,
    farmComments?.UNRESOLVED,
    farmComments?.DELETED
  );
  const farmerCommentsArr = safeConcat(
    farmerComments?.RESOLVED,
    farmerComments?.UNRESOLVED,
    farmerComments?.DELETED
  );

  return [...farmCommentsArr, ...farmerCommentsArr];
}

export const getUniqueComments = (newComments, oldComments) => {
  const uniqueCommentIds = new Set([]);

  newComments.forEach((el) => {
    if (el && Object.hasOwn(el, 'comment_id') && el.comment_id) {
      uniqueCommentIds.add(el.comment_id);
    }
  });

  const combinedArr = [...newComments];

  oldComments?.forEach((el) => {
    if (el && el.comment) {
      const commentKeys = Object.keys(commentId);
      const foundComment = commentKeys.find((obj) => obj.includes(el.comment.trim()));
      if (foundComment && !uniqueCommentIds.has(commentId[foundComment])) {
        uniqueCommentIds.add(commentId[foundComment]);
        combinedArr.push(el);
      }
    }
  });

  return combinedArr;
};

export const getOldCommentsStr = (farmCommentsStr, farmerCommentsStr) => {
  let str = '';
  if (farmCommentsStr) str += farmCommentsStr;

  if (farmerCommentsStr) str += farmerCommentsStr;

  console.log(str);
  return str;
};

export const downloadFile = async (s3Url, fileName) => {
  try {
    const response = await api.get(s3Url, {
      responseType: 'blob' // important to get binary data
    });
    saveAs(response.data, fileName);
  } catch (error) {
    console.error('Error downloading the pdf:', error);
  }
};

export const capitalizeFullName = (name) => {
  if (!name) return '';
  return name
    .trim()
    .split(' ')
    .filter((word) => word.length > 0)
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const debounce = (fn, delay) => {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

export const getStatusColor = (status) => {
  const upperStatus = (status || '').toUpperCase();

  switch (upperStatus) {
    case 'SUBMITTED':
      return '#1e8e3e'; // Green

    case 'NOT_STARTED':
      return '#1a73e8'; // Blue

    case 'DRAFT':
      return '#e65100'; // Orange

    default:
      return '#757575'; // Grey
  }
};
